<div class="alert alert-success" *ngIf="alertSuccess">
  Uploaded successfully!
</div>
<div class="alert alert-success" *ngIf="alertUpdateSuccess">
  Updated successfully!
</div>
<div class="alert alert-danger" *ngIf="alertFailure">
  {{errorMsg}} !
</div>
<div class="alert alert-success" *ngIf="deleteSuccess">
  Deleted successfully!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-danger" *ngIf="errorMsgUploadSave">
  Uploading failed and data will not be saved!
</div>

<div class="common-padding">

  <!-- <h4 class="headspace">CHAPTER RESOURCES</h4> -->
  <div class="col-md-12 col-xs-12 col-sm-12 heading p-0 mt-4 mb-4">
    <span class="span-create-edit-hoshin color">CHAPTER RESOURCES</span>
    <span class="pt-1" style="font-size: 13px;"><a href="assets/userguides/ChapterResourcesUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
  </div>
  <form class="admin-font-style" (ngSubmit)="onDocumentRepositorySubmit()" action="" name="documentRepositoryForm"
    #documentRepositoryForm="ngForm" enctype="multipart/form-data">
    <div>
      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad" [ngClass]="{'pointerDisable': editandSavebtn ==true && savebtn == false}">
        <label for="site" class="col-md-3 zeroLeftPad">Select Site<span class="star"> *</span></label>
        <ng-select id="site" [ngClass]="{'disableSection': editandSavebtn ==true && savebtn == false}" placeholder="--Select Site--" class="col-md-8" [items]="siteList" name="siteName"
          bindLabel="siteName" [(ngModel)]="selectedSite" (change)="siteChange($event)" required></ng-select>
      </div>
      <div class="col-md-6 inlineFlex zeroRightPad" [ngClass]="{'pointerDisable': editandSavebtn ==true && savebtn == false}">
        <span class="divide-width"></span>
        <label for="bpg" class="col-md-3">Select ERG <span class="star"> *</span></label>
        <ng-select id="bpg" [ngClass]="{'disableSection': editandSavebtn ==true && savebtn == false}" placeholder="--Select ERG--" class="col-md-8 zeroRightPad" [items]="bpgList" name="bpgName"
          bindLabel="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)" required></ng-select>
      </div>

      <div class="col-md-6 inlineFlex leftFloat zeroLeftPad">
        <label for="selectFolder" class="col-md-3 zeroLeftPad">Select Folder <span class="star"> *</span></label>
        <ng-select id="selectFolder" placeholder="--Select Folder--" class="col-md-8" [items]="folderList" name="folderName"
          bindLabel="folderName" bindValue="folderId" [(ngModel)]="selectedFolder" required></ng-select>
        <a class="manage-folder-link" routerLink='../manage-folder'>Manage Folder</a>
      </div>

      <div class="col-md-6 inlineFlex zeroRightPad">
        <span class="divide-width"></span>
        <label class="col-md-3" [ngClass]="{'addMargin': eventPicture == false}" for="docName">Title<span
            class="star">*</span></label>
        <input type="text" [maxlength]="50" class="form-control col-md-8 zeroRightPad placeholder" name="docName"
          id="docName" placeholder="Title" [(ngModel)]="documentName" required>
      </div>



      <div class="col-md-6 inlineFlex upload-position" [ngClass]="{'pointerDisable': editandSavebtn ==true && savebtn == false}">
        <label class="col-md-3 zeroLeftPad upload-label-padding" for="UploadDocument">Upload<span class="star">
            *</span></label>

        <input [ngClass]="{'disableSection': editandSavebtn ==true && savebtn == false}" #myInput type="file" id="UploadDocument" (change)="onFileSelected($event)" name="UploadDocument"
          placeholder="Upload" class="form-control input-lg upload-icon hideInput">
        <label [ngClass]="{'disableSection': editandSavebtn ==true && savebtn == false}" class="form-control input-lg upload-icon col-md-8 width-label" for="UploadDocument"><label
            class="docNameEllipsis resource-ellipsis col-md-8 upload-file-name-class ">{{selectedFileName}}</label>
          <p class="formats-font">( mp3, xlx, xlsx, csv, doc, docx, txt, pdf, ppt, pptx, jpg, jpeg, png )</p>
          <p class="errorMessage" *ngIf="fileSizeExtensionError">You can only upload the
            file of size less than 500 MB </p>
          <p class="errorMessage" *ngIf="fileExtensionError">Invalid format</p>
        </label>

      </div>

    </div>
    <div class="top-space text-center col-md-12">

      <button type="submit" id="submitButton" *ngIf="editandSavebtn ==false && savebtn == true"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width"
        [disabled]="(!documentRepositoryForm.valid || isFileUploded == false )  || fileSizeExtensionError"
        data-target="#myModal" data-toggle="modal">SAVE</button>
      <button type="submit" id="submitButton" *ngIf="editandSavebtn ==true && savebtn == false"
        class="btn btn-danger col-sm-2 col-md-2 style btn-width" [disabled]="!documentRepositoryForm.valid "
        data-target="#myModal" data-toggle="modal">SAVE AND UPDATE</button>
      <span class="preview"></span>
      <button type="button" class="btn btn-danger col-sm-2 col-md-2 style btn-width" data-toggle="modal"
        (click)="resetClick()" data-target="#myModal">RESET</button>
    </div>

  </form>

  <div class="col-md-12  search-div-style">

    <div class="col-md-3 div-bottom"> 
      <ng-select placeholder="--Select Site--" [items]="siteListSearch" name="siteName" bindLabel="siteName"
        [(ngModel)]="selectedSiteSearch" (change)="siteChangeSearch($event)" required></ng-select>
    </div>
    <div class="col-md-3  div-bottom">
      <ng-select placeholder="--Select ERG--" [items]="bpgListSearch" name="bpgName" bindLabel="bpgName"
        [(ngModel)]="selectedBpgSearch" (change)="bpgChangeSearch($event)"></ng-select>
    </div>

    <div class="col-md-3  div-bottom">
      <ng-select placeholder="--Select Folder--" [items]="folderListForSearch" name="folderName1" bindLabel="folderName"
        bindValue="folderId" [(ngModel)]="selectedFolderForSearch" required></ng-select>
    </div>


    <div class="col-md-2 div-bottom">

      <button type="button" class="btn btn-danger search-button-style gallery-but"
        (click)="getChapterGalleryListSearch()">Search</button>
    </div>
  </div>
</div>


<!--table-->
<p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
<div class="tabledemo1" *ngIf="tableShow">
  <div class="table-container">
  <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
    <thead>
      <tr class="tr-th">
        <th scope="col" class="doc-name-title" style="width:3%"></th>
        <th scope="col" class="doc-name-title" style="width:30%">Doc Name</th>
        <th scope="col" style="width:10%">Site</th>
        <th scope="col" style="width:15%">ERG</th>
        <th scope="col" style="width:27%">Folder</th>
        <th scope="col" style="width:15%">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of galleryItemsList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
        <td >
          <img class="doc-icons" src="assets/images/pdf-doc.png" alt="Angular Logo" *ngIf="(data.fileName.toLowerCase().indexOf('.pdf') !== -1)">
          <img class="doc-icons" src="assets/images/txt-doc.png" alt="Angular Logo" *ngIf="(data.fileName.toLowerCase().indexOf('.txt') !== -1)">
          <img class="doc-icons" src="assets/images/word-doc.png" alt="Angular Logo" *ngIf="(data.fileName.toLowerCase().indexOf('.doc') !== -1) || (data.fileName.toLowerCase().indexOf('.docx') !== -1)">
          <img class="doc-icons" src="assets/images/excel-doc.png" alt="Angular Logo" *ngIf="(data.fileName.toLowerCase().indexOf('.xls') !== -1) || (data.fileName.toLowerCase().indexOf('.xlsx') !== -1) ||  (data.fileName.toLowerCase().indexOf('.csv') !== -1)">
          <img class="doc-icons" src="assets/images/ppt-doc.png" alt="Angular Logo" *ngIf="(data.fileName.toLowerCase().indexOf('.ppt') !== -1) || (data.fileName.toLowerCase().indexOf('.pptx') !== -1)">
          <img class="doc-icons" src="assets/images/audio-doc.png" alt="Angular Logo" *ngIf="(data.fileName.toLowerCase().indexOf('.mp3') !== -1)">
          <img class="doc-icons" src="assets/images/image-doc.png" alt="Angular Logo" *ngIf="(data.fileName.toLowerCase().indexOf('.jpg') !== -1) || (data.fileName.toLowerCase().indexOf('.jpeg') !== -1) ||  (data.fileName.toLowerCase().indexOf('.png') !== -1)">
        </td>
      <td> {{data.documentName}}</td>
        <td>{{data.siteName}}</td>
        <td>{{data.bpgName}}</td>
        <td>{{data.folderName}}</td>
        <td class="edit-delete-button">
          <a id="edit{{i}}" (click)="editDocument(data,i)" class="edit-delete"><img src="assets/images/edit.png" alt="Angular Logo"
              class="image" title="Edit"></a>
          <a id="edit{{i}}" (click)="deleteGalleryConfirmation(data.galleryId)" class="edit-delete"
            data-target="#myModal" data-toggle="modal"><img src="assets/images/delete.png" alt="Angular Logo" class="image"
              title="Delete"></a>
          <a downloadAttachments-btn id='downloadFiles{{i}}' class="edit-delete"
            (click)="downloadDocument(data.fileName,i)">
            <img src="assets/images/download-new.png" class="image delete-icon download-icon" alt="Angular Logo" title="Download"></a>
        </td>
      </tr>
    </tbody>
  </table>
  </div>
  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>

</div>
<app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
